import { useLazyLoadQuery } from "react-relay";
import { discountActionsScreen_Query } from "@relay/discountActionsScreen_Query.graphql";
import { useDiscountActionSearchContext } from "./discount-actions.context";
import { QUERY } from "./discount-actions.graphql";
import { DiscountActionsTable } from "./parts/discount-actions-table";
import { useHasPermissions } from "../../hooks/use-has-permissions";

export const DiscountActionsQueryContainer = () => {
	const { isArchivePage } = useDiscountActionSearchContext();
	const canModify = useHasPermissions(["UserInAccountPermission_DiscountAdmin_Modify"]);
	const query = useLazyLoadQuery<discountActionsScreen_Query>(
		QUERY,
		{ first: 20, filterByIsArchived: isArchivePage },
		{ fetchPolicy: "network-only" },
	);

	return (
		<DiscountActionsTable
			key={isArchivePage ? "archived-discount-actions" : "active-discount-actions"}
			discountActionsQueryFragment={query}
			canModifyDiscountActions={canModify}
		/>
	);
};
